const FormSelect = ({
  propId,
  options,
  valueKey,
  labelKey,
  changeHandler = null,
  blankOption = true,
  ariaLabel = undefined,
}) => {
  return (
    <>
      <select
        id={propId}
        className='rounded-sm border border-solid border-gray-300 px-2 py-1'
        data-cy='form-select'
        aria-label={ariaLabel}
        onChange={changeHandler}
      >
        {blankOption && <option></option>}
        {options &&
          options.map(option => {
            return (
              <option value={option[valueKey]} key={option[valueKey]}>
                {option[labelKey]}
              </option>
            );
          })}
      </select>
    </>
  );
};

export default FormSelect;
